import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion'; // ✅ Fixed import
import { useCart } from '../context/CartContext';
import '../styles/SalesContainer.css';

const categories = [
  'All',
  'T-shirt',
  'Shirt',
  'Caps',
  'Shorts',
  'Trousers',
  'Skirts',
  'Tops',
  'Dress'
];

function SalesContainer() {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('All');
    const { addToCart } = useCart();

  useEffect(() => {
    fetch('https://shophub-server.vercel.app/api/products')
      .then(res => res.json())
      .then(data => {
        setProducts(data);
        setFilteredProducts(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    if (category === 'All') {
      setFilteredProducts(products);
    } else {
      const filtered = products.filter(
        product => product.category?.toLowerCase() === category.toLowerCase()
      );
      setFilteredProducts(filtered);
    }
  };

  if (loading) return <p className="text-center mt-10">Loading products...</p>;

  return (
    <>
      {/* NAVIGATION BAR */}
      <motion.div
        className="mt-20 bg-salescontainer py-4"
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <div className="flex flex-wrap justify-center gap-0.5 md:gap-11 px-4 md:px-20">
          {categories.map((cat) => (
            <motion.button
              key={cat}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => handleCategoryClick(cat)}
              className={`px-4 py-2 rounded-xl text-[1rem] transition ${
                activeCategory === cat
                  ? 'bg-currentnav text-white'
                  : 'text-searchtext hover:bg-gray-200'
              }`}
            >
              {cat}
              
            </motion.button>
            
          ))}
      <div className="flex justify-end px-8 mt-4 spin">
        <i className="bx bx-search bx-md text-currentnav cursor-pointer spin"></i>
      </div>
        </div>
        
      </motion.div>


      {/* PRODUCT GRID */}
      <div className="bg-salescontainer py-10">
        <div className="salescontainer flex flex-wrap gap-6 ">
          <AnimatePresence>
            {filteredProducts.map((product) => (
              <motion.div
                key={product._id}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.3 }}
                className="bg-clothe flex flex-col items-center rounded-lg p-4 w-full max-w-[260px]"
              >
                <Link to={`/product/${product._id}`} className="w-full flex justify-center">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-[200px] object-contain mb-3"
                  />
                </Link>

                <div className="bg-white rounded-md p-3 w-full">
                  <h1 className="text-[1.1rem] font-semibold text-currentnav">
                    {product.name}
                  </h1>
                  <h2 className="text-navtext text-sm mb-1">{product.description}</h2>
                  <h3 className="text-[1.1rem] font-medium text-currentnav">
                    ${product.price}
                  </h3>

                  <div className="mt-4 flex justify-end">
                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      type="button"
                      className="bg-currentnav text-white text-xs px-4 py-1 rounded-lg hover:opacity-90"
                      onClick={() => addToCart(product)}
                    >
                      Add to cart
                    </motion.button>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
          {filteredProducts.length === 0 && (
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-gray-600 mt-10 text-center"
            >
              No products in this category
            </motion.p>
          )}
        </div>
      </div>
    </>
  );
}

export default SalesContainer;
